import { useEffect, useRef } from 'react'
import { KeyEvent } from '../../constants/enums'
import { registerKeyHandler } from '../../state/state.keys'

/**
 * While `open`, an overlay owns Escape: the last one opened takes the press
 * alone, so one press closes one thing, even while typing. Without `onClose`
 * the press still stops here, and nothing under the overlay closes instead.
 */
export const useEscapeKey = (open: boolean, onClose?: () => void) => {
    const onCloseRef = useRef(onClose)
    useEffect(() => {
        onCloseRef.current = onClose
    })

    useEffect(() => {
        if (!open) return
        return registerKeyHandler(
            KeyEvent.Keydown,
            () => onCloseRef.current?.(),
            ['Escape'],
            { exclusive: true, whileTyping: true },
        )
    }, [open])
}
